import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import { LIVE } from "./live/flag.js";

// Mount the React root. Fail fast if the mount node is missing (no silent
// no-op) — it means index.html and this entry have drifted.
const root = document.getElementById("root");
if (!root) {
  throw new Error("#root element not found in index.html");
}

if (LIVE) {
  // ?live=1 (Track 2), or the clean build (always live): sign in first, then the same app. The live code — Amplify included —
  // is a separate chunk fetched only here, so the snapshot site never downloads it.
  import("./live/boot.js")
    .then(({ bootLive }) => bootLive(root, <App />))
    .catch((err: unknown) => {
      // A missing setting or a failed chunk download: say so on screen — above the loading
      // screen (z-index 100000), which would otherwise spin forever — then fail loud.
      const msg = document.createElement("p");
      msg.style.cssText =
        "position:fixed;inset:0;z-index:100001;margin:0;display:grid;place-items:center;padding:24px;background:#121212;color:#ffb4c0;font-family:system-ui,sans-serif;";
      msg.textContent = `Live mode failed to start: ${String(err)}`;
      document.body.appendChild(msg);
      throw err;
    });
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
